import { Suspense, lazy } from "react";
import { useSprint26FlagVisible } from "../lib/featureFlags.js";

/**
 * E-BUNDLE-19 — Ladeschranke vor dem Demo-Banner.
 *
 * `DemoWorkspaceBanner` haengt an `sprint26.demoWorkspace`, einem Flag der
 * Klasse `internal_admin_only` mit Default OFF. Der Wert steht erst nach dem
 * Netz-Roundtrip auf `GET /v1/feature-flags` fest, das Banner kann beim ersten
 * Paint also gar nichts zeichnen — trotzdem lag es samt Kopie-Schluesseln,
 * StatePill und Layout-Styles fest im Entry-Chunk.
 *
 * Die Schranke prueft dasselbe Flag und laedt das Modul erst bei Sichtbarkeit
 * nach. Die Komponente selbst ist nicht angefasst; sie prueft das Flag
 * weiterhin selbst, ein zu frueh geladener Chunk zeigt dort schlicht `null`.
 */
const DemoWorkspaceBanner = lazy(async () => {
  const mod = await import("./DemoWorkspaceBanner.js");
  return { default: mod.DemoWorkspaceBanner };
});

export function DemoWorkspaceBannerGate() {
  const { visible } = useSprint26FlagVisible("sprint26.demoWorkspace");
  if (!visible) return null;
  return (
    <Suspense fallback={null}>
      <DemoWorkspaceBanner />
    </Suspense>
  );
}
